var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCitas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-calendar",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-calendar:not(.animated) .animable {opacity: 0;}svg#freepik_stories-calendar.animated #freepik--Calendar--inject-248 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-calendar.animated #freepik--Character--inject-248 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-248",
    className: "animable",
    style: {
      transformOrigin: "269.36px 342.242px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--SUELO--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.4,411.34c80.06,38.15,209.86,38.15,289.92,0s80.05-100,0-138.18-209.86-38.16-289.92,0S44.35,373.18,124.4,411.34Z",
    style: {
      fill: "rgb(235, 235, 235)",
      opacity: 0.5,
      transformOrigin: "269.36px 342.242px"
    },
    className: "animable",
    id: "el8t2hv4rlra6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-248",
    className: "animable",
    style: {
      transformOrigin: "337.367px 355.524px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-248",
    cx: 383.84,
    cy: 313.58,
    rx: 55.32,
    ry: 26.37,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "383.84px 313.58px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-248",
    d: "M300.18,418.55c-14.78,7.05-38.74,7.05-53.52,0s-14.78-18.46,0-25.51,38.74-7,53.52,0S315,411.51,300.18,418.55Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "273.427px 405.804px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-248",
    className: "animable",
    style: {
      transformOrigin: "149.571px 322.502px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-248",
    className: "animable",
    style: {
      transformOrigin: "149.571px 322.502px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.4,328.59l8.13-4.69s4.29-19.13-2.1-43.43S82.61,238,73,241.81s-9.36,11-4.06,18.29c4.4,6,18.67,20.6,25.53,37.42A92.57,92.57,0,0,1,101.4,328.59Z",
    style: {
      fill: "current",
      transformOrigin: "88.1127px 284.947px"
    },
    id: "elv1ea60femrm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elr66p7rlbeue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.4,328.59l8.13-4.69s4.29-19.13-2.1-43.43S82.61,238,73,241.81s-9.36,11-4.06,18.29c4.4,6,18.67,20.6,25.53,37.42A92.57,92.57,0,0,1,101.4,328.59Z",
    style: {
      opacity: 0.1,
      transformOrigin: "88.1127px 284.947px"
    },
    className: "animable",
    id: "elvgfwr8hfj9i"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.73,326.59h-.07a.5.5,0,0,1-.42-.56c5.55-40-19.24-72.34-30.52-79.09a.5.5,0,1,1,.51-.85c11.45,6.84,36.62,39.61,31,80.08A.51.51,0,0,1,105.73,326.59Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "90.7278px 286.286px"
    },
    id: "el5to149ch4yf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.4,328.59l-12.18,7a23.22,23.22,0,0,0-8.13-2.34c-5.18-.65-8.63-5.65-8.12-9.38.34-2.52,1.15-5.39.76-7.94-.34-2.28-2.55-4.33-4.61-5.13a17,17,0,0,0-5.42-.77c-2.93-.14-6-.47-8.47-2s-4.29-4.59-3.49-7.42a10,10,0,0,1,2.55-3.85A12.26,12.26,0,0,0,57,293c1.08-2.82-.83-4.62-3.1-5.93-8-4.6-11.6-8.23-8.72-11.71s10.79-5,18.9-.74,14.84-.31,20.19.59c8.38,1.4,8.87,7.32,7.83,12.46S101.43,295,104,301.17C105.93,305.65,107.51,320.37,101.4,328.59Z",
    style: {
      fill: "current",
      transformOrigin: "74.9616px 303.809px"
    },
    id: "el4pb6udatcz5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.34,331.43a.5.5,0,0,1-.5-.48c-1-28.55-37.59-53.45-46.22-54.88a.5.5,0,0,1-.42-.57.51.51,0,0,1,.58-.41c9.09,1.5,46.05,26.21,47.06,55.82a.5.5,0,0,1-.48.52Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "74.0173px 303.257px"
    },
    id: "elnarfdlk4l2f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.26,383c-.4-5-4.26-13.54-10-19.62s-14.86-9-20.5-6.56c-5.25,2.28-4.09,9.32,2.84,13.49s17.25,9.27,20.79,17.16l6.84,9.47Z",
    style: {
      fill: "current",
      transformOrigin: "237.375px 376.449px"
    },
    id: "elinhx5bipob",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elz2res73yyu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.26,383c-.4-5-4.26-13.54-10-19.62s-14.86-9-20.5-6.56c-5.25,2.28-4.09,9.32,2.84,13.49s17.25,9.27,20.79,17.16l6.84,9.47Z",
    style: {
      opacity: 0.1,
      transformOrigin: "237.375px 376.449px"
    },
    className: "animable",
    id: "el9lbdoqv023b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.26,392.16h.1a.68.68,0,0,0,.58-.77c-2.49-18.53-21.32-31.42-28.81-32.84a.68.68,0,0,0-.8.54.68.68,0,0,0,.54.8c7,1.33,25.34,14.08,27.71,31.68A.69.69,0,0,0,254.26,392.16Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "240.132px 375.349px"
    },
    id: "elssxh1qd1dmc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.52,403.7c-1-2.75-4.84-7.12-10.71-10.5-6.49-3.75-14.42-5.08-16.48-8.23-2.47-3.8.57-7.81,6.94-7.54s18.18,8,21,20.83Z",
    style: {
      fill: "current",
      transformOrigin: "239.872px 390.559px"
    },
    id: "el4pyxnzlrb6t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,401h.13a.68.68,0,0,0,.54-.81c-1.89-9.5-15.66-19.34-24.56-19.75a.72.72,0,0,0-.72.65.7.7,0,0,0,.66.72c8.26.38,21.53,9.85,23.28,18.65A.68.68,0,0,0,254,401Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "242.037px 390.72px"
    },
    id: "elknee5c6ihwj",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calendar--inject-248",
    className: "animable",
    style: {
      transformOrigin: "234.903px 212.859px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--calendar--inject-248",
    className: "animable",
    style: {
      transformOrigin: "234.903px 212.859px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.66,336a3.5,3.5,0,0,1-1.48-3.61l35.46-156.94a6.51,6.51,0,0,1,2.71-3.69l211-121.8a4.64,4.64,0,0,1,4.2-.07A3.5,3.5,0,0,1,346,53.48L310.53,210.42a6.49,6.49,0,0,1-2.72,3.69L96.86,335.91A4.64,4.64,0,0,1,92.66,336Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "218.59px 192.94px"
    },
    id: "elzqkhh3kacg8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.7,177.77l-35.46,157c-.3,1.34.42,1.88,1.62,1.19l211-121.8a6.49,6.49,0,0,0,2.72-3.69L346,53.48c.3-1.35-.42-1.88-1.62-1.19l-211,121.8A6.52,6.52,0,0,0,130.7,177.77Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "220.62px 194.124px"
    },
    id: "eldy29hpk32cq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.57,52.21a4.64,4.64,0,0,0-4.2.08l-211,121.8a4,4,0,0,0-1.81,3.72L159.33,372.2a5.63,5.63,0,0,0,2.39,3.65,4.59,4.59,0,0,0,4.19-.08L376.87,254a4,4,0,0,0,1.81-3.73L351,55.86A5.62,5.62,0,0,0,348.57,52.21Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "255.12px 214.032px"
    },
    id: "elf7893760vk9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.66,180.16l27.73,194.39a1.57,1.57,0,0,0,2.52,1.22L376.87,254a4,4,0,0,0,1.81-3.73L351,55.86a1.57,1.57,0,0,0-2.52-1.23L137.48,176.43A4,4,0,0,0,135.66,180.16Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "257.17px 215.2px"
    },
    id: "elywp9y7f6rkd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.43,333.89l54-31.19L151,314l-24.76,14.3s-6.6,2.34-9.22,3S95.43,333.89,95.43,333.89Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "123.215px 318.295px"
    },
    id: "el4t0o8y5o6r5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.03 314.01 159.13 370.81 126.27 328.31 151.03 314.01",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "142.7px 342.41px"
    },
    id: "el615aljdf8zu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.16,372.7l-29.45-38.25a4.72,4.72,0,0,0-4-1.63l-27.54,4a8.11,8.11,0,0,1-4.51-.82c-1.12-.64-.93-1.38.42-1.64l31.65-6.09a4.35,4.35,0,0,1,4,1.53L162.26,375c.82,1.11.58,1.48-.54.83A14.53,14.53,0,0,1,158.16,372.7Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "127.338px 352.186px"
    },
    id: "el4nn32tyrhnl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.05,52.71a3.43,3.43,0,0,0-1.54-2.84,4.68,4.68,0,0,0-4.2.08l-211,121.8a5.94,5.94,0,0,0-1.65,1.54,6.1,6.1,0,0,0-1.07,2.15l-5,22.17,4.06,2.33L341,75.64l5-22.16a3.6,3.6,0,0,0,.06-.77Z",
    style: {
      fill: "current",
      transformOrigin: "233.826px 124.676px"
    },
    id: "elup4858bb0ib",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elp1xuukud0db"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346,53.48c.3-1.35-.42-1.88-1.62-1.19l-211,121.8a6.52,6.52,0,0,0-2.71,3.68l-5,22.17L341,75.64Z",
    style: {
      opacity: 0.2,
      transformOrigin: "235.869px 125.964px"
    },
    className: "animable",
    id: "eleh525whwb5l"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el8xv3qveomth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.76,175.63a5.86,5.86,0,0,0-1.06,2.14l-5,22.17-4.06-2.34,5-22.17a6.1,6.1,0,0,1,1.07-2.15Z",
    style: {
      opacity: 0.1,
      transformOrigin: "126.7px 186.61px"
    },
    className: "animable",
    id: "elq6491g2wvcb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elh5cbksjcgba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.05,52.7c-.1-.75-.75-1-1.68-.41l-211,121.79a5.71,5.71,0,0,0-1.65,1.55l-4.06-2.35a5.94,5.94,0,0,1,1.65-1.54l211-121.8a4.68,4.68,0,0,1,4.2-.08A3.43,3.43,0,0,1,346.05,52.7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "236.855px 112.516px"
    },
    className: "animable",
    id: "elqn0gw51fv6l"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M351.21,57.72h0L351,55.86a2.61,2.61,0,0,0-.06-.27.25.25,0,0,0,0-.08h0a5.67,5.67,0,0,0-2.31-3.3,4.64,4.64,0,0,0-4.2.08l-211,121.8a3.75,3.75,0,0,0-1.45,1.66h0a3.76,3.76,0,0,0-.36,2.06l4,27.85,4.06,2.35L354.93,83.72Z",
    style: {
      fill: "current",
      transformOrigin: "243.264px 129.878px"
    },
    id: "el1biiwy1fg9a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elu0iaxtnf9f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.64,208l-4.06-2.35-4-27.85a3.76,3.76,0,0,1,.36-2.06l4.07,2.34a3.69,3.69,0,0,0-.37,2.06Z",
    style: {
      opacity: 0.1,
      transformOrigin: "135.599px 191.87px"
    },
    className: "animable",
    id: "elslcekxvi1t8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el2mb87wx2lph"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.88,55.51a1.54,1.54,0,0,0-2.44-.88l-211,121.8a3.69,3.69,0,0,0-1.45,1.66L132,175.75a3.83,3.83,0,0,1,1.45-1.67l211-121.79a4.64,4.64,0,0,1,4.2-.08A5.63,5.63,0,0,1,350.88,55.51Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "241.44px 114.918px"
    },
    className: "animable",
    id: "elutsnr7bspz"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.65,342.34l-2.52-17.71a1.26,1.26,0,0,0-2-1l-18.39,10.62a3.18,3.18,0,0,0-1.45,3L173.8,355a1.25,1.25,0,0,0,2,1l18.39-10.62A3.17,3.17,0,0,0,195.65,342.34Z",
    style: {
      fill: "current",
      transformOrigin: "183.472px 339.82px"
    },
    id: "elj2iqcu2c55",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.09,325.94l-2.53-17.7a1.25,1.25,0,0,0-2-1l-18.39,10.61a3.19,3.19,0,0,0-1.45,3l2.53,17.71a1.25,1.25,0,0,0,2,1l18.39-10.62A3.17,3.17,0,0,0,224.09,325.94Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "211.906px 323.4px"
    },
    id: "elr3ten9pl9dn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.53,309.54,250,291.84a1.25,1.25,0,0,0-2-1L229.6,301.47a3.19,3.19,0,0,0-1.45,3l2.53,17.71a1.25,1.25,0,0,0,2,1l18.39-10.62A3.17,3.17,0,0,0,252.53,309.54Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "240.341px 307.01px"
    },
    id: "el5pu8yx4gbku",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,293.15l-2.53-17.71a1.25,1.25,0,0,0-2-1L258,285.08a3.17,3.17,0,0,0-1.45,3l2.53,17.7a1.25,1.25,0,0,0,2,1l18.39-10.61A3.19,3.19,0,0,0,281,293.15Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "268.773px 290.61px"
    },
    id: "el6oh128xxf6l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.41,276.75,306.88,259a1.25,1.25,0,0,0-2-1l-18.39,10.62a3.17,3.17,0,0,0-1.45,3l2.53,17.7a1.25,1.25,0,0,0,2,1L308,279.73A3.19,3.19,0,0,0,309.41,276.75Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "297.225px 274.16px"
    },
    id: "elq1vwa79udr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.85,260.35l-2.53-17.71a1.25,1.25,0,0,0-2-1l-18.39,10.62a3.17,3.17,0,0,0-1.45,3L316,273a1.25,1.25,0,0,0,2,1l18.39-10.62A3.18,3.18,0,0,0,337.85,260.35Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "325.666px 257.82px"
    },
    id: "el5lj3pyx8upc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.29,244l-2.53-17.71a1.25,1.25,0,0,0-2-1l-18.39,10.62a3.18,3.18,0,0,0-1.45,3l2.52,17.71a1.26,1.26,0,0,0,2,1l18.39-10.62A3.18,3.18,0,0,0,366.29,244Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "354.105px 241.45px"
    },
    id: "el2xs8c3cihq3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.71,307.69,188.18,290a1.26,1.26,0,0,0-2-1l-18.39,10.62a3.18,3.18,0,0,0-1.45,3l2.52,17.71a1.26,1.26,0,0,0,2,1l18.39-10.62A3.22,3.22,0,0,0,190.71,307.69Z",
    style: {
      fill: "current",
      transformOrigin: "178.525px 305.165px"
    },
    id: "elufbi1kfh9ea",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.15,291.29l-2.53-17.71a1.26,1.26,0,0,0-2-1l-18.39,10.62a3.18,3.18,0,0,0-1.45,3l2.52,17.71a1.26,1.26,0,0,0,2,1l18.39-10.62A3.22,3.22,0,0,0,219.15,291.29Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "206.964px 288.745px"
    },
    id: "elnpuhkj9hcc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.59,274.89l-2.53-17.71a1.26,1.26,0,0,0-2-1l-18.39,10.62a3.18,3.18,0,0,0-1.45,3l2.52,17.71a1.26,1.26,0,0,0,2,1l18.39-10.62A3.22,3.22,0,0,0,247.59,274.89Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "235.404px 272.345px"
    },
    id: "elmdnhoo6y4y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,258.49l-2.53-17.71a1.26,1.26,0,0,0-2-1L253.1,250.42a3.19,3.19,0,0,0-1.45,3l2.52,17.71a1.26,1.26,0,0,0,2,1l18.39-10.62A3.21,3.21,0,0,0,276,258.49Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "263.826px 255.955px"
    },
    id: "el1vpc4lisk26",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.47,242.09l-2.53-17.7a1.25,1.25,0,0,0-2-1L281.54,234a3.19,3.19,0,0,0-1.45,3l2.52,17.71a1.26,1.26,0,0,0,2,1L303,245.07A3.21,3.21,0,0,0,304.47,242.09Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "292.278px 239.545px"
    },
    id: "eluvi76ddftse",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.91,225.69,330.38,208a1.25,1.25,0,0,0-2-1L310,217.63a3.17,3.17,0,0,0-1.45,3l2.52,17.7a1.26,1.26,0,0,0,2,1l18.39-10.62A3.21,3.21,0,0,0,332.91,225.69Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "320.73px 223.16px"
    },
    id: "elt3sota5o3lc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.35,209.3l-2.53-17.71a1.25,1.25,0,0,0-2-1l-18.4,10.62a3.18,3.18,0,0,0-1.44,3l2.52,17.7a1.26,1.26,0,0,0,2,1l18.39-10.61A3.23,3.23,0,0,0,361.35,209.3Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "349.163px 206.745px"
    },
    id: "el8ttesnwskfi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.76,273l-2.52-17.71a1.26,1.26,0,0,0-2-1L162.83,265a3.21,3.21,0,0,0-1.45,3l2.53,17.7a1.25,1.25,0,0,0,2,1L184.31,276A3.19,3.19,0,0,0,185.76,273Z",
    style: {
      fill: "current",
      transformOrigin: "173.571px 270.5px"
    },
    id: "elbkf8tp5oni6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.2,256.64l-2.52-17.71a1.26,1.26,0,0,0-2-1l-18.39,10.62a3.21,3.21,0,0,0-1.45,3l2.53,17.71a1.26,1.26,0,0,0,2,1l18.39-10.62A3.18,3.18,0,0,0,214.2,256.64Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "202.021px 254.095px"
    },
    id: "elfspdiivxa9h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.64,240.24l-2.52-17.71a1.26,1.26,0,0,0-2-1l-18.39,10.62a3.22,3.22,0,0,0-1.45,3l2.53,17.71a1.26,1.26,0,0,0,2,1l18.39-10.62A3.18,3.18,0,0,0,242.64,240.24Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "230.461px 237.695px"
    },
    id: "el0ai2dj39goid",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.08,223.84l-2.52-17.71a1.26,1.26,0,0,0-2-1l-18.39,10.62a3.22,3.22,0,0,0-1.45,3l2.53,17.71a1.26,1.26,0,0,0,2,1l18.39-10.62A3.18,3.18,0,0,0,271.08,223.84Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "258.901px 221.295px"
    },
    id: "elwamccr4oef",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.52,207.44,297,189.73a1.26,1.26,0,0,0-2-1l-18.39,10.62a3.22,3.22,0,0,0-1.45,3l2.53,17.71a1.26,1.26,0,0,0,2,1l18.39-10.62A3.18,3.18,0,0,0,299.52,207.44Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "287.341px 204.895px"
    },
    id: "eljmv5xhdz2p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,191l-2.52-17.71a1.26,1.26,0,0,0-2-1L305,183a3.22,3.22,0,0,0-1.45,3l2.53,17.71a1.26,1.26,0,0,0,2,1L326.51,194A3.17,3.17,0,0,0,328,191Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "315.775px 188.5px"
    },
    id: "eln5qkgg4qjj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.4,174.64l-2.52-17.7a1.26,1.26,0,0,0-2-1l-18.39,10.61a3.21,3.21,0,0,0-1.45,3l2.53,17.71a1.26,1.26,0,0,0,2,1L355,177.62A3.17,3.17,0,0,0,356.4,174.64Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "344.222px 172.1px"
    },
    id: "elahbxmvoa9qh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.82,238.38l-2.53-17.7a1.25,1.25,0,0,0-2-1l-18.39,10.61a3.19,3.19,0,0,0-1.45,3L159,251a1.25,1.25,0,0,0,2,1l18.39-10.62A3.17,3.17,0,0,0,180.82,238.38Z",
    style: {
      fill: "current",
      transformOrigin: "168.636px 235.84px"
    },
    id: "elo4ljb4mtqz8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.26,222l-2.53-17.7a1.25,1.25,0,0,0-2-1l-18.39,10.62a3.17,3.17,0,0,0-1.45,3l2.53,17.7a1.25,1.25,0,0,0,2,1L207.81,225A3.17,3.17,0,0,0,209.26,222Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "197.075px 219.46px"
    },
    id: "el1y6idbxadkqj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.7,205.59l-2.53-17.71a1.25,1.25,0,0,0-2-1l-18.39,10.62a3.17,3.17,0,0,0-1.45,3l2.53,17.7a1.25,1.25,0,0,0,2,1l18.39-10.61A3.19,3.19,0,0,0,237.7,205.59Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "225.514px 203.04px"
    },
    id: "elzyvm12xzqc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.14,189.19l-2.53-17.71a1.25,1.25,0,0,0-2-1l-18.39,10.62a3.17,3.17,0,0,0-1.45,3l2.52,17.71a1.26,1.26,0,0,0,2,1l18.39-10.62A3.19,3.19,0,0,0,266.14,189.19Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "253.954px 186.64px"
    },
    id: "elh01ac6v6iq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.58,172.79l-2.53-17.71a1.25,1.25,0,0,0-2-1l-18.39,10.62a3.17,3.17,0,0,0-1.45,3l2.52,17.71a1.26,1.26,0,0,0,2,1l18.39-10.62A3.18,3.18,0,0,0,294.58,172.79Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "282.394px 170.24px"
    },
    id: "elq3lvi0886ns",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,156.39l-2.53-17.71a1.25,1.25,0,0,0-2-1l-18.39,10.62a3.18,3.18,0,0,0-1.45,3L301.16,169a1.26,1.26,0,0,0,2,1l18.39-10.62A3.18,3.18,0,0,0,323,156.39Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "310.815px 153.835px"
    },
    id: "elek8em86b0c9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.46,140l-2.53-17.71a1.25,1.25,0,0,0-2-1l-18.39,10.62a3.18,3.18,0,0,0-1.45,3l2.52,17.71a1.26,1.26,0,0,0,2,1L350,143A3.18,3.18,0,0,0,351.46,140Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "339.275px 137.45px"
    },
    id: "elwyb8i8zlivc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.45,207.08l-.64-4.52a1.25,1.25,0,0,0-2-1L155.41,212.2a3.18,3.18,0,0,0-1.45,3l.63,4.52a1.26,1.26,0,0,0,2,1L175,210.06A3.21,3.21,0,0,0,176.45,207.08Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "165.203px 211.135px"
    },
    id: "elgc9kvp5wfi9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.89,190.68l-.64-4.52a1.25,1.25,0,0,0-2-1L183.85,195.8a3.18,3.18,0,0,0-1.45,3l.63,4.52a1.26,1.26,0,0,0,2,1l18.4-10.62A3.21,3.21,0,0,0,204.89,190.68Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "193.645px 194.735px"
    },
    id: "elbo6lr538408",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.33,174.28l-.64-4.52a1.26,1.26,0,0,0-2-1L212.29,179.4a3.18,3.18,0,0,0-1.45,3l.63,4.52a1.25,1.25,0,0,0,2,1l18.4-10.62A3.21,3.21,0,0,0,233.33,174.28Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "222.085px 178.345px"
    },
    id: "elit1wsmuhsvp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.77,157.89l-.64-4.53a1.26,1.26,0,0,0-2-1L240.73,163a3.18,3.18,0,0,0-1.45,3l.63,4.52a1.25,1.25,0,0,0,2,1l18.4-10.61A3.23,3.23,0,0,0,261.77,157.89Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "250.524px 161.945px"
    },
    id: "elaf6vjt6ozud",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.21,141.49l-.64-4.53a1.26,1.26,0,0,0-2-1L269.17,146.6a3.19,3.19,0,0,0-1.45,3l.63,4.52a1.25,1.25,0,0,0,2,1l18.4-10.61A3.23,3.23,0,0,0,290.21,141.49Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "278.965px 145.545px"
    },
    id: "el7wpvz478zn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.65,125.09l-.64-4.52a1.25,1.25,0,0,0-2-1L297.61,130.2a3.19,3.19,0,0,0-1.45,3l.63,4.53a1.26,1.26,0,0,0,2,1l18.4-10.62A3.22,3.22,0,0,0,318.65,125.09Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "307.405px 129.145px"
    },
    id: "elp29d7jeky3d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.08,108.69l-.63-4.52a1.25,1.25,0,0,0-2-1l-18.39,10.62a3.17,3.17,0,0,0-1.45,3l.63,4.52a1.26,1.26,0,0,0,2,1l18.4-10.62A3.19,3.19,0,0,0,347.08,108.69Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "335.845px 112.735px"
    },
    id: "eleiuefwt1rrd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2bxifso9vaz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155,180.38a7.26,7.26,0,0,1,3.44-6.68c2.24-1.29,4.33-.4,4.68,2a7.23,7.23,0,0,1-3.45,6.68C157.44,183.67,155.35,182.78,155,180.38Z",
    style: {
      opacity: 0.2,
      transformOrigin: "159.06px 178.04px"
    },
    className: "animable",
    id: "elr85evlg8sa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellt66oy2jsr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.47,164a7.24,7.24,0,0,1,3.44-6.68c2.24-1.3,4.33-.41,4.68,2a7.22,7.22,0,0,1-3.45,6.67C185.9,167.24,183.81,166.35,183.47,164Z",
    style: {
      opacity: 0.2,
      transformOrigin: "187.53px 161.639px"
    },
    className: "animable",
    id: "eluh82sn6p0m"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elc5quu7m57qe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.88,147.55a7.24,7.24,0,0,1,3.44-6.68c2.24-1.3,4.34-.41,4.68,2a7.23,7.23,0,0,1-3.44,6.67C214.32,150.83,212.22,149.94,211.88,147.55Z",
    style: {
      opacity: 0.2,
      transformOrigin: "215.94px 145.202px"
    },
    className: "animable",
    id: "eliyowu2i8kkq"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elr3fjts8w8gq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.74,114.72a7.24,7.24,0,0,1,3.44-6.68c2.24-1.29,4.33-.4,4.67,2a7.2,7.2,0,0,1-3.44,6.68C271.17,118,269.08,117.12,268.74,114.72Z",
    style: {
      opacity: 0.2,
      transformOrigin: "272.796px 112.378px"
    },
    className: "animable",
    id: "eln6k33cg6dp"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elwume66g364p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.2,98.3a7.22,7.22,0,0,1,3.44-6.68c2.24-1.3,4.33-.41,4.68,2a7.23,7.23,0,0,1-3.45,6.68C299.63,101.58,297.54,100.69,297.2,98.3Z",
    style: {
      opacity: 0.2,
      transformOrigin: "301.26px 95.9536px"
    },
    className: "animable",
    id: "el2ljrzc7amhm"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ell3l7287z1lb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.61,81.89a7.24,7.24,0,0,1,3.44-6.68c2.24-1.3,4.34-.41,4.68,2a7.23,7.23,0,0,1-3.44,6.67C328,85.17,326,84.28,325.61,81.89Z",
    style: {
      opacity: 0.2,
      transformOrigin: "329.67px 79.5419px"
    },
    className: "animable",
    id: "elo9hm0vnsjec"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.06,153.36c-3-1.75-5.94-2-8.18-.71s-3.48,3.93-3.48,7.44a18.15,18.15,0,0,0,.72,4.85l1.78-1a16.12,16.12,0,0,1-.5-3.83c0-2.76.88-4.79,2.48-5.71a4.26,4.26,0,0,1,2.15-.54,8.3,8.3,0,0,1,4,1.25c5.32,3.08,9.65,10.58,9.65,16.72a10.91,10.91,0,0,1-.07,1.31,5.52,5.52,0,0,1-2.4,4.4,4.6,4.6,0,0,1-3,.48,5.68,5.68,0,0,0-.25,2,7.27,7.27,0,0,0,1.13.09,6.13,6.13,0,0,0,3.14-.82,7.09,7.09,0,0,0,3.27-5.14,13,13,0,0,0,.2-2.3C162.71,165,157.93,156.75,152.06,153.36Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "151.55px 165.974px"
    },
    id: "elj9yszepwlw9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.52,136.94c-3-1.75-5.94-2-8.18-.71s-3.48,3.93-3.48,7.44a18.15,18.15,0,0,0,.72,4.85l1.78-1a16.12,16.12,0,0,1-.5-3.83c0-2.76.88-4.79,2.48-5.71a4.26,4.26,0,0,1,2.15-.54,8.3,8.3,0,0,1,4,1.25c5.32,3.08,9.65,10.58,9.65,16.72a10.91,10.91,0,0,1-.07,1.31,5.52,5.52,0,0,1-2.4,4.4,4.6,4.6,0,0,1-3,.48,5.68,5.68,0,0,0-.25,2,7.27,7.27,0,0,0,1.13.09,6.13,6.13,0,0,0,3.14-.82,7.09,7.09,0,0,0,3.27-5.14,13,13,0,0,0,.2-2.3C191.17,148.61,186.39,140.33,180.52,136.94Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "180.01px 149.554px"
    },
    id: "el20ic7ajt75x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.93,120.53c-3-1.75-5.94-2-8.18-.71s-3.48,3.93-3.48,7.44a18.15,18.15,0,0,0,.72,4.85l1.78-1a16.12,16.12,0,0,1-.5-3.83c0-2.76.88-4.79,2.48-5.71a4.26,4.26,0,0,1,2.15-.54,8.3,8.3,0,0,1,4,1.25c5.32,3.08,9.65,10.58,9.65,16.72a10.91,10.91,0,0,1-.07,1.31,5.52,5.52,0,0,1-2.4,4.4,4.6,4.6,0,0,1-3,.48,5.68,5.68,0,0,0-.25,2,7.27,7.27,0,0,0,1.13.09,6.13,6.13,0,0,0,3.14-.82,7.09,7.09,0,0,0,3.27-5.14,13,13,0,0,0,.2-2.3C219.58,132.2,214.8,123.92,208.93,120.53Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "208.42px 133.144px"
    },
    id: "elghlovhok4p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.8,87.75c-3-1.75-5.94-2-8.18-.71s-3.48,3.93-3.48,7.44a18.15,18.15,0,0,0,.72,4.85l1.78-1a16.12,16.12,0,0,1-.5-3.83c0-2.76.88-4.79,2.48-5.71a4.26,4.26,0,0,1,2.15-.54,8.3,8.3,0,0,1,4,1.25c5.32,3.08,9.65,10.58,9.65,16.72a10.91,10.91,0,0,1-.07,1.31,5.52,5.52,0,0,1-2.4,4.4,4.6,4.6,0,0,1-3,.48,5.68,5.68,0,0,0-.25,2,7.27,7.27,0,0,0,1.13.09,6.13,6.13,0,0,0,3.14-.82,7.09,7.09,0,0,0,3.27-5.14,13,13,0,0,0,.2-2.3C276.45,99.42,271.67,91.14,265.8,87.75Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "265.29px 100.364px"
    },
    id: "elw98yjybamn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.26,71.32c-3-1.75-5.94-2-8.18-.71s-3.48,3.93-3.48,7.44a18.15,18.15,0,0,0,.72,4.85l1.78-1a16.12,16.12,0,0,1-.5-3.83c0-2.76.88-4.79,2.48-5.71a4.26,4.26,0,0,1,2.15-.54,8.3,8.3,0,0,1,4,1.25c5.32,3.08,9.65,10.58,9.65,16.72a10.91,10.91,0,0,1-.07,1.31,5.52,5.52,0,0,1-2.4,4.4,4.6,4.6,0,0,1-3,.48,5.68,5.68,0,0,0-.25,2,7.27,7.27,0,0,0,1.13.09,6.13,6.13,0,0,0,3.14-.82,7.09,7.09,0,0,0,3.27-5.14,13,13,0,0,0,.2-2.3C304.91,83,300.13,74.71,294.26,71.32Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "293.75px 83.9335px"
    },
    id: "el34cqc2i9oah",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.67,54.91c-3-1.75-5.94-2-8.18-.71S311,58.13,311,61.64a18.15,18.15,0,0,0,.72,4.85l1.78-1a16.12,16.12,0,0,1-.5-3.83c0-2.76.88-4.79,2.48-5.71a4.26,4.26,0,0,1,2.15-.54,8.3,8.3,0,0,1,4,1.25c5.32,3.08,9.65,10.58,9.65,16.72a10.91,10.91,0,0,1-.07,1.31,5.52,5.52,0,0,1-2.4,4.4,4.6,4.6,0,0,1-3,.48,5.68,5.68,0,0,0-.25,2,7.27,7.27,0,0,0,1.13.09,6.13,6.13,0,0,0,3.14-.82,7.09,7.09,0,0,0,3.27-5.14,13,13,0,0,0,.2-2.3C333.32,66.58,328.54,58.3,322.67,54.91Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "322.15px 67.5235px"
    },
    id: "el0f8qguzpxwyj",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-248",
    className: "animable",
    style: {
      transformOrigin: "385.037px 275.325px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-248",
    className: "animable",
    style: {
      transformOrigin: "385.037px 275.325px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.22,315l-6.72,11.67A3.18,3.18,0,0,0,351,330l6.76-11.74c.65-1.12-.05-2.75-1.57-3.63S352.87,313.91,352.22,315Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "351.52px 322.804px"
    },
    id: "elred6rns15vo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.7,294.45l11.67,6.72a3.18,3.18,0,1,0,3.26-5.46L408.89,289c-1.12-.65-2.75.05-3.63,1.57S404.58,293.8,405.7,294.45Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "413.467px 295.202px"
    },
    id: "elgcyatwrm6d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.63,241.84h0l-.06,0h0l-28.43-16.41h0l-.08,0h0c-6.24-3.55-14.84-3-24.33,2.46-19.07,11-34.53,37.79-34.53,59.81,0,11,3.85,18.69,10.06,22.31h0l.05,0h0l28.43,16.42h0l.07,0h0c6.24,3.57,14.85,3,24.35-2.45,19.06-11,34.52-37.79,34.52-59.8C428.68,253.18,424.84,245.46,418.63,241.84Z",
    style: {
      fill: "current",
      transformOrigin: "379.94px 275.935px"
    },
    id: "elwdvanb2373",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el83ytplmjtup"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.28,326.1l-28-16.14h0l-.06,0c-6.21-3.63-10.05-11.35-10.05-22.31,0-9.82,3.08-20.58,8.17-30.46l28.43,16.41c-5.1,9.88-8.17,20.64-8.17,30.46C359.62,314.76,363.3,322.38,369.28,326.1Z",
    style: {
      opacity: 0.1,
      transformOrigin: "350.225px 291.645px"
    },
    className: "animable",
    id: "el6w2txp53sob"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el5pf29bze0x5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 394.16,
    cy: 284.09,
    rx: 48.83,
    ry: 28.19,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "394.16px 284.09px",
      transform: "rotate(-60deg)"
    },
    className: "animable",
    id: "elbwvmglh4y8v"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M378.73,321.67c-10.92,0-12.1-12.34-12.1-17.65,0-19.42,14.21-44,31-53.74,4.28-2.47,8.4-3.77,11.92-3.77,10.92,0,12.1,12.34,12.1,17.65,0,19.42-14.21,44-31,53.74-4.29,2.47-8.41,3.77-11.92,3.77Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "394.14px 284.09px"
    },
    id: "elkdrhgprdsj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.5,306.59a.45.45,0,0,1-.16,0,.51.51,0,0,1-.31-.64l7.65-21.85a.5.5,0,0,1,.95.33L387,306.25A.49.49,0,0,1,386.5,306.59Z",
    style: {
      fill: "current",
      transformOrigin: "390.331px 295.18px"
    },
    id: "elnzusjbd5q3r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.62,290.69a1.39,1.39,0,0,1-.59-.12l-12.37-5.35V262.78a1.5,1.5,0,0,1,3,0v20.47l10.56,4.57a1.5,1.5,0,0,1-.6,2.87Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "399.885px 275.985px"
    },
    id: "elvekrrwwtyc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.16,279.4c2.24-1.3,4.06-.25,4.06,2.34a9,9,0,0,1-4.06,7c-2.25,1.3-4.07.25-4.07-2.35A9,9,0,0,1,394.16,279.4Z",
    style: {
      fill: "current",
      transformOrigin: "394.155px 284.07px"
    },
    id: "el2mkhbc0pls6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.12,263.3c-4.9,8.47-14.13,12.31-21.07,8.3a17.73,17.73,0,0,1,17.75-30.7C364.72,245,366,254.82,361.12,263.3Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "347.623px 255.857px"
    },
    id: "ell44jkihpea",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.05,271.6c6.94,4,16.17.17,21.07-8.3a22.54,22.54,0,0,0,2.41-6.08c-.28.37-8.44,10.77-18.58,7.84-10.32-3-12.26-10.93-11.37-17.69A17.73,17.73,0,0,0,340.05,271.6Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "347.363px 260.28px"
    },
    id: "el83xph99qchi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.2,245.65l-5.26-3a3.18,3.18,0,1,0-3.26,5.46l5.32,3.08c1.13.65,2.76-.05,3.64-1.57S338.32,246.3,337.2,245.65Z",
    style: {
      fill: "current",
      transformOrigin: "332.638px 246.803px"
    },
    id: "elk4dr2pgzepd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.66,220.28l3-5.25a3.18,3.18,0,1,0-5.46-3.26l-3.08,5.32c-.65,1.12,0,2.75,1.57,3.63S415,221.41,415.66,220.28Z",
    style: {
      fill: "current",
      transformOrigin: "414.503px 215.724px"
    },
    id: "elhysvlu1gh0w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.25,222.45A17.73,17.73,0,1,1,421,240.2Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "406.814px 226.886px"
    },
    id: "elvzajhqpijxd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.1,217.84c1,2.09,3.72,10.94,0,13.14s-20.9-5.1-20.9-5.1L421,240.2A17.74,17.74,0,0,0,417.1,217.84Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "409.779px 229.02px"
    },
    id: "el0z06osd9t46n",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-248",
    className: "animable",
    style: {
      transformOrigin: "273.572px 311.004px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-248",
    className: "animable",
    style: {
      transformOrigin: "273.572px 311.004px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.87,268.51c-17.7-23.79-23.52-26.44-26.85-27.25l5.84,16L296,272.83",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "291.445px 257.045px"
    },
    id: "elri686z2q8yh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.29,241s3.76-1.14,9.2,4.19,12,13.1,12,13.1-1.77,6.35-7.3,8.32l-8-8.32Z",
    style: {
      fill: "current",
      transformOrigin: "286.89px 253.754px"
    },
    id: "elr7a4g2f5t1d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfti4jrh5zfc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.29,241s3.76-1.14,9.2,4.19,12,13.1,12,13.1-1.77,6.35-7.3,8.32l-8-8.32Z",
    style: {
      opacity: 0.1,
      transformOrigin: "286.89px 253.754px"
    },
    className: "animable",
    id: "elncmzqkwkuls"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elrht6iur38qj"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 277.41,
    cy: 217.93,
    r: 10.16,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "277.41px 217.93px",
      transform: "rotate(-13.28deg)"
    },
    className: "animable",
    id: "elyenndunlw8n"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el43co4i72ohd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 253.07,
    y: 389.87,
    width: 7.16,
    height: 12.25,
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "256.65px 395.995px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "el5qk082bon44"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "276.42 393.22 283.57 393.47 283.93 380.5 276.77 380.25 276.42 393.22",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "280.175px 386.86px"
    },
    id: "eludyuotffbe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.54,292.74v49.51c-.17,2-1.62,5.37-2,13.74-.48,10.27,1.09,38.53,1.09,38.53s3.35,3.33,8.09,0c0,0,6.35-40.34,7.64-50.51,1.12-8.88,3-33,3-33l4.28,36.33s-1.17,6.67-1.42,11.37,2.06,29.83,2.06,29.83a7.83,7.83,0,0,0,7.79.29s4.9-37.65,5.64-41.9-2.69-54.2-2.69-54.2Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "270.632px 344.365px"
    },
    id: "eltflso5w0q0c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.42,243.29a16.48,16.48,0,0,0-2.95.69c-2,.77-2.87,3.19-3.34,5.32a25.22,25.22,0,0,0-.59,5.44v38c5,5.46,22.52,8,33.48,0,0,0-.21-33.56-1-39.08-1.43-9.58-6-13-10.62-12.64l-11.05,1.58Z",
    style: {
      fill: "current",
      transformOrigin: "270.28px 269.413px"
    },
    id: "el1xmrzk1vzfu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.84,225.16s1.65,7.73,2.31,9a3.54,3.54,0,0,0,2,1.64l-.12-5.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "261.995px 230.48px"
    },
    id: "el3zhz3vjonsw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.91,214.07a3.84,3.84,0,0,0-3.16,1.11c-1.35,1.39-.59,5.73,1.09,10l3.11.35Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "260.503px 219.788px"
    },
    id: "el54pmn2f35l6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.88,225.51c-.63.38-1.51-.82-2.28-1.62s-3.27-1.9-4.52.73,1.1,6.23,3.07,6.85c3.4,1.06,3.91-1.12,3.91-1.12l.26,12.26a10.93,10.93,0,0,0,8.25,6.26c6,.81,4.78-4.15,2.8-6.59v-3.73a21.47,21.47,0,0,0,4.58.24c2.5-.39,4.07-2.36,4.83-5.06,1.22-4.35,1.68-7.85.65-16.4-1.14-9.36-12-9.46-17.91-5.76S263.88,225.51,263.88,225.51Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "271.364px 229.128px"
    },
    id: "elfhpqp0wpmtu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.88,226.56c-.32,0-1.51-2-2.28-2.67-1.07-1,.31-9.82.31-9.82a4.18,4.18,0,0,1,1-4.47c1.46-1.62,3.92-1.79,8.11-2.45,2.2-.35,5.54-1,7.74-1.37,2.62-.49,4.79-1,6.64.6a4.63,4.63,0,0,1,1.29,5.21,4.39,4.39,0,0,1-.75,1.12c-.53.59-.62,1.39-1.37,1.63,0,0-1.59,1.44-5.57,1.92a58.77,58.77,0,0,1-11-.21c-1.16-.16-1.47.21-2.09,3.26C265.38,222,264.93,226.54,263.88,226.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "274.103px 215.928px"
    },
    id: "elr9ygmdh6b8p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.92,214.76l-3.76-2a2.06,2.06,0,0,1,2.84-.94A2.25,2.25,0,0,1,261.92,214.76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "260.152px 213.167px"
    },
    id: "elzjy071nzy4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.36,238.55s-5.57-1.12-7.52-2.16a6.41,6.41,0,0,1-2.7-2.66,8.88,8.88,0,0,0,1.53,3.14c1.43,1.82,8.69,3.17,8.69,3.17Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "270.25px 236.885px"
    },
    id: "el5ybrb03yw8x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.38,225.14a1.12,1.12,0,1,1-1.12-1.16A1.13,1.13,0,0,1,274.38,225.14Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "273.261px 225.1px"
    },
    id: "els8hd1lx194k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.19,220.93l-2.39,1.31a1.44,1.44,0,0,1,.56-1.9A1.33,1.33,0,0,1,273.19,220.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "271.916px 221.21px"
    },
    id: "el39emeomg4pr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.86,231.84l2.55,1a1.33,1.33,0,0,1-1.73.84A1.41,1.41,0,0,1,274.86,231.84Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "276.086px 232.802px"
    },
    id: "el2yhqme642gq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,221.86l-2.18-1.68a1.32,1.32,0,0,1,1.9-.29A1.44,1.44,0,0,1,284.34,221.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "283.385px 220.735px"
    },
    id: "el37r27p6v32j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.67,224.83a1.13,1.13,0,0,1-1.12,1.15,1.16,1.16,0,1,1,1.12-1.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "282.51px 224.821px"
    },
    id: "el0r7w6xedvs1s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.62 222.74 277.99 229.46 281.5 228.27 277.62 222.74",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "279.56px 226.1px"
    },
    id: "elshbwq3eksif",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.23,398.59v-1c.69.29,2.28,6.37,5.12,9,2.26,2.06,5.34,4.43,6.12,6.73s-4.29,3.71-6.4,3.33c-2.45-.43-6.7-2.16-7.76-3.76s-1.57-4-2.44-5.13-2.86-2.48-3.33-3.84a8.66,8.66,0,0,1,.41-3.76c.33-1.26.69-2.65,1.12-2.53,0,.15,0,.78,0,.78a5.75,5.75,0,0,0,3.58,1.21C257.7,399.6,260.24,399.39,260.23,398.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "261.519px 407.151px"
    },
    id: "elz7xotiaj1nr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.64,391.26c.38,0,.68.54,1.5,1.43a15.63,15.63,0,0,0,4.21,3c2.68,1.35,7.89,3.41,10.25,4.47,1.47.67,1.4,2.45-.12,3.46s-5.2,1.74-9.61.75c-2.41-.53-5.54-2.76-7.52-2.64s-5.69.1-7.15-.91-.88-3.16-.47-5c.45-2,1.1-5.11,1.77-5l0,.64c.87,1.3,5.25,1.83,7.14.88Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "287.463px 397.829px"
    },
    id: "elb6v56fuwcct",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.36,311a26.46,26.46,0,0,0,10-5.71s-1.92,3.6-7.64,6.95l.12,19.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "276.36px 318.52px"
    },
    id: "elbnf11ze278",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.79,310.7c-1.18-1-1.92-2.29-3.7-3.6a9.5,9.5,0,0,1-3.15-3.19c-1-1.68-2-7.28-2.3-12.6a52.3,52.3,0,0,1,2.47-17.53c2.43-6.71,7.36-15.71,9-19.51s.76-5.71-.71-7.64c-1.72-2.26-4.91-2.27-7.92,2.88a110.42,110.42,0,0,0-9.54,22.61,55.13,55.13,0,0,0-1.73,18.07c.33,5.63,1.56,9.93,3.14,15.34.44,1.47.39,2.67.89,5.58a12.41,12.41,0,0,0,.92,3.53,16.08,16.08,0,0,0,2.57,3.71,10.76,10.76,0,0,0,4.79,3,6.69,6.69,0,0,0,3.11.17,4.44,4.44,0,0,0,2.65-1.56,1.27,1.27,0,0,0,.28-.57,1.46,1.46,0,0,0-.41-1,64.54,64.54,0,0,1-4-5.2c-.92-1.55-1.36-2.78-1-2.71s.83,1,2.17,1.84,3,.81,3.39.06S259,311.72,257.79,310.7Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "250.535px 283.406px"
    },
    id: "el44rs9iaorf7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.28,243.75c-2.86.17-5.46.81-8.32,6.48s-7.35,16.29-7.35,16.29a12.32,12.32,0,0,0,10.93,6.31s6.58-13.74,7.65-17.36S263,246,258.28,243.75Z",
    style: {
      fill: "current",
      transformOrigin: "252.299px 258.291px"
    },
    id: "ell2ez62wqarg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elkwbubm4xit"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.28,243.75c-2.86.17-5.46.81-8.32,6.48s-7.35,16.29-7.35,16.29a12.32,12.32,0,0,0,10.93,6.31s6.58-13.74,7.65-17.36S263,246,258.28,243.75Z",
    style: {
      opacity: 0.1,
      transformOrigin: "252.299px 258.291px"
    },
    className: "animable",
    id: "el5dfhxs7okcy"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M296,272.83c-.65,1.9-6.89,7.69-11.48,9.53a6.28,6.28,0,0,1-3.38.2,8.48,8.48,0,0,0-3.4-.66c-1.34.12-2.7.38-4.05.54a2,2,0,0,0-.81.2c-.82.45-.35,1.14.3,1.39a23.93,23.93,0,0,0,3.21.91l0,.29a32.11,32.11,0,0,1-8.66,1.74,2.42,2.42,0,0,0-1.45.5,1.52,1.52,0,0,0-.33,1.42,3.7,3.7,0,0,0,.7,1.33,8.31,8.31,0,0,0,5.22,3.55,16.15,16.15,0,0,0,6.39-.8q1.49-.42,2.94-.93a66.67,66.67,0,0,0,8.25-3.69,74.44,74.44,0,0,0,15.74-11.07c2.88-2.81,2.17-5.51-.25-8.77",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "286.481px 281.163px"
    },
    id: "elzfjlp1as36o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.85,282.54s1-.37,2.14,1.46,1.86,5.17.43,5.83a2.84,2.84,0,0,0,2.52-1.25,7.09,7.09,0,0,0-2.52-7.12A3.79,3.79,0,0,0,283.85,282.54Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "286.482px 285.647px"
    },
    id: "elxcszybkd9c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.14,283.21a2.12,2.12,0,1,1-2.88-.76A2.11,2.11,0,0,1,289.14,283.21Z",
    style: {
      fill: "current",
      transformOrigin: "287.315px 284.287px"
    },
    id: "el9u9fp78c57l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.65,283.49a1.56,1.56,0,1,1-2.12-.57A1.55,1.55,0,0,1,288.65,283.49Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "287.302px 284.274px"
    },
    id: "el8fm8pzgye0h",
    className: "animable"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitas);
export default __webpack_public_path__ + "static/media/citas.6caaa661.svg";
export { ForwardRef as ReactComponent };